import PropTypes from "prop-types";
import React from "react";

import EditRouteForm from "v2/components/responsive/EditRouteForm";

const EditRoutePage = (props, context) => {
  const {location: {query}, params: {date, routeId}, router} = context;
  return (
    <EditRouteForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}/${routeId}`,
          query,
        });
      }} />
  );
};

EditRoutePage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default EditRoutePage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/EditRoutePage.js
 **/